import './App.css';
import Home from './screen/Home';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from './screen/Login';
import Register from './screen/Register';
import { CardProvider } from './components/ContextReducer';
import MyOrder from './screen/Myorder';




function App() {
  return (
    <CardProvider>
      <Router>
        <div>
          <Routes>
            <Route exact path='/' element={<Home />} />
            <Route exact path='/login' element={<Login />} />
            <Route exact path='/register' element={<Register />} />
            <Route exact path='/myoder' element={<MyOrder />} />
            
          </Routes>
        </div>
      </Router>
    </CardProvider>

  );
}

export default App;
